import { useEffect, useState } from 'react';
import { Alert, Card, CardContent, Chip, CircularProgress, Stack, Typography } from '@mui/material';
import PushPin from '@mui/icons-material/PushPin';
import { useMarcarNovedadesLeidas, useMisNovedades } from '../hooks/useNovedades';
import { formatDate } from '../utils/format';

export default function Novedades() {
  const { data, isLoading, error } = useMisNovedades();
  const marcar = useMarcarNovedadesLeidas();
  // Las que estaban sin leer al abrir la pantalla siguen marcadas "Nueva" mientras se mira
  const [nuevas, setNuevas] = useState<Set<string> | null>(null);

  useEffect(() => {
    if (!data || nuevas) return;
    const ids = data.filter((n) => !n.leida).map((n) => n.id);
    setNuevas(new Set(ids));
    if (ids.length > 0) marcar.mutate(ids);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, nuevas]);

  const novedades = data ?? [];
  return (
    <Stack spacing={2}>
      <div>
        <Typography variant="h5" fontWeight={700}>
          Novedades
        </Typography>
        <Typography color="text.secondary">Lo que el gremio comunica y te corresponde.</Typography>
      </div>
      {isLoading && <CircularProgress size={28} />}
      {error && <Alert severity="error">No pudimos cargar las novedades.</Alert>}
      {!isLoading && !error && novedades.length === 0 && <Alert severity="info">No hay novedades por ahora.</Alert>}
      {novedades.map((n) => (
        <Card key={n.id} component="article" sx={{ borderLeft: 5, borderLeftColor: n.fijada ? 'warning.main' : 'primary.main' }}>
          <CardContent>
            <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
              <Typography variant="h6">{n.titulo}</Typography>
              <Stack direction="row" spacing={0.5} flexShrink={0}>
                {nuevas?.has(n.id) && <Chip size="small" color="warning" label="Nueva" />}
                {n.fijada && <Chip size="small" icon={<PushPin />} label="Fijada" />}
              </Stack>
            </Stack>
            <Typography sx={{ mt: 1, whiteSpace: 'pre-line' }}>{n.cuerpo}</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
              {formatDate(n.publicada_at)}
              {n.vence_el ? ` · vigente hasta el ${formatDate(n.vence_el)}` : ''}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </Stack>
  );
}
